/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationRecapQuery from '../graphql/queries/GetSimulationRecapQuery.js';

const useGetSimulationRecapQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationRecapQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationRecap: R.omit(['__typename'], data?.getSimulationRecap_simulation_recap || {})
  };
};

export default useGetSimulationRecapQuery;
